const getters = {
  getWorkflowData(state) {
    return state.workflowApprovalData;
  },
};

export default getters;
